import get from './get';

type Keys = string | Array<any>;

const exists = (thing: any, ...rest: Keys[]): any => {
  if (rest.length > 0) {
    // @ts-ignore
    thing = get(thing, ...rest);
    return exists(thing);
  }

  return typeof thing !== 'undefined' && thing !== null;
};

export default exists;
